module.exports = __webpack_public_path__ + "img/1920x700-3.a0c01779.jpg";